interface UAEState {
  name: string;
  code: string;
  isoCode: string;
}

export const UAEStates = [
  { name: "Abu Dhabi", code: "AE-AZ" },
  { name: "Ajman", code: "AE-AJ" },
  { name: "Dubai", code: "AE-DU" },
  { name: "Fujairah", code: "AE-FU" },
  { name: "Ras al-Khaimah", code: "AE-RK" },
  { name: "Sharjah", code: "AE-SH" },
  { name: "Umm al-Quwain", code: "AE-UQ" },
];
  
  export const UAEStatesMap: Record<string, UAEState> = {
    'AE-AZ': { name: 'Abu Dhabi', code: 'AUH', isoCode: 'AE-AZ' },
    'AE-AJ': { name: 'Ajman', code: 'QAJ', isoCode: 'AE-AJ' },
    'AE-DU': { name: 'Dubai', code: 'DXB', isoCode: 'AE-DU' },
    'AE-FU': { name: 'Fujairah', code: 'FJR', isoCode: 'AE-FU' },
    'AE-RK': { name: 'Ras al-Khaimah', code: 'RKT', isoCode: 'AE-RK' },
    'AE-SH': { name: 'Sharjah', code: 'SHJ', isoCode: 'AE-SH' },
    'AE-UQ': { name: 'Umm al-Quwain', code: 'OMUQ', isoCode: 'AE-UQ' },
  };
  